import { reduce, flowRight } from "lodash"
import { buildRouteTemplates } from "./routes/_routesBuilder"

const routeTemplatesRaw = buildRouteTemplates()

const flattenRouteTemplates = (routeTemplates) => {
  let flattenedRouteTemplates = []

  routeTemplates.forEach((rt) => {
    flattenedRouteTemplates.push(rt)

    if (rt.children != null) {
      flattenedRouteTemplates = flattenedRouteTemplates.concat(flattenRouteTemplates(rt.children))
    }
  })

  return flattenedRouteTemplates
}

const reduceRouteTemplates = (routeTemplates) => {
  return reduce(
    routeTemplates,
    (reducedRouteTemplates, rt) => {
      return {
        ...reducedRouteTemplates,
        [rt.id]: {
          ...rt,
          children: rt.children != null ? flattenRouteTemplates(rt.children) : [],
        },
      }
    },
    {},
  )
}

export const routeTemplates = flowRight(reduceRouteTemplates, flattenRouteTemplates)(routeTemplatesRaw)
